// Какую причину недоступности модуля ПОКАЗЫВАТЬ человеку.
//
// ┌─ Зачем отдельная функция ─────────────────────────────────────────────────┐
// │ Причина `tier_locked` рисуется текстами «{module} is on a paid plan» и    │
// │ «See plans». В мобильной сборке тарифной системы не видно вовсе: App Store│
// │ дважды завернул StudyHub по 3.1.1, второй раз — за то, что в приложении   │
// │ видна платная функциональность, которую нельзя купить через IAP.          │
// │                                                                          │
// │ Сама причина при этом остаётся настоящей (модуль действительно выше       │
// │ тарифа), и прятать её от кода нельзя — прятать надо формулировку. Для     │
// │ человека в приложении раздел, до которого не дотягивает тариф, выглядит   │
// │ как выключенный: материалы на месте, создавать новое нельзя.              │
// └──────────────────────────────────────────────────────────────────────────┘
//
// Потребителей четыре — гард маршрута, сцена персонажа, плитка инструмента и
// текст серверного отказа (`lib/user-facing-error.ts`), — и
// правило в каждом из них своё было бы ровно тем «пропуском в одной из копий»,
// который уже случался с условием видимости коммерции.

/**
 * Причина для текстов `layout:moduleState.<reason>.*` и `errors:moduleUnavailable.<reason>`.
 *
 * Обобщённая, потому что причин два словаря с одним и тем же набором значений:
 * клиентский резолвер (`UnavailableReason`) и контракт ошибки сервера
 * (`ModuleUnavailableReason`). Отдельные копии правила под каждый — как раз то,
 * от чего эта функция защищает.
 *
 * `commerceVisible` — из `useCommerceVisible()` / `isCommerceVisible()`.
 */
export function presentedUnavailableReason<R extends string>(
	reason: R,
	commerceVisible: boolean,
): R | "product_disabled" {
	if (reason === "tier_locked" && !commerceVisible) return "product_disabled";
	return reason;
}
